import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	forwardRef,
	HostBinding,
	HostListener,
	inject,
	Input
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

import {ICONS} from './icons';

const SELECT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => IconInputComponent),
	multi: true
};

@Component({
	selector: 'ic-icon-input',
	templateUrl: './input.component.html',
	providers: [SELECT_CONTROL_ACCESSOR],
	styleUrls: ['./input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class IconInputComponent implements ControlValueAccessor {
	private cdRef = inject(ChangeDetectorRef);
	private eRef = inject(ElementRef);

	@HostBinding('class.error') @Input() error = false;

	@Input() icon: string;
	@Input() placeholder: string;
	@Input() label: string;
	@Input() disabled = false;
	@Input() required = true;
	@Input() help: string;
	@Input() missing = false;
	@Input() missingText: string;

	icons: string[] = ICONS;

	selected: string;
	hasFocus = false;

	private onChange: (v: unknown) => void;
	private onTouch: () => void;

	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this.eRef.nativeElement.contains(event.target)) {
			this.hasFocus = false;
		}
	}

	selectIcon(icon: string) {
		if (this.disabled) {
			return;
		}
		if (this.selected !== icon) {
			this.selected = icon;
		} else {
			this.selected = '';
		}
		this.onChange(this.selected);
		this.onTouch();
		this.hasFocus = false;
		this.cdRef.detectChanges();
	}

	setFocus() {
		if (this.disabled) {
			return;
		}
		this.hasFocus = !this.hasFocus;
	}

	writeValue(selected: string): void {
		this.selected = selected;
		this.cdRef.markForCheck();
	}

	registerOnChange(fn: (v: unknown) => void) {
		this.onChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}

	setDisabledState(isDisabled: boolean) {
		this.disabled = isDisabled;
	}
}
